import {
  Animals,
  COMERCIALIZADOR,
  CRUZADO_1,
  CRUZADO_2,
  FRISON,
  FRISON_MACHO_KEY,
  HEMBRA,
  MACHO,
  MONTBELIARD_SIMMENTAL_ETC,
  PRODUCTOR,
  SELECTO,
  VACA,
  VACA_KEY,
  VACUNO,
  VACUNO_HEMBRA_KEY,
  VACUNO_MACHO_KEY,
} from "../utils/constants";

const getDataFromOpinionsTable = (table, headers, sex, personType) => {
  return table.slice(2).flatMap((row, index) => {
    const name = row[1]?.replace(/\s\s+/g, " ");
    const personId = row[0];
    return (
      row
        .slice(2)
        // Convert non numeric values to null except for =
        .map((cell) => (cell === "=" ? cell : isNaN(cell) ? null : cell))
        .map((cell, index) => {
          return {
            personName: name,
            personId: personId,
            personType,
            opinion: cell === "=" ? 0 : cell,
            animal: {
              sex,
              ...headers[index],
            },
          };
        })
        // Filter empty cells
        .filter((cell) => cell.opinion !== null)
        // Filter cells with name null or empty
        .filter(
          (cell) =>
            cell.personName !== undefined &&
            cell.personName !== "" &&
            cell.personName !== null
        )
    );
  });
};

const getDataFromAvgOpinionsTable = (table, sex, headers) => {
  const personTypes = [COMERCIALIZADOR, PRODUCTOR, "total"];
  return table.slice(2).flatMap((row, index) => {
    const personType = personTypes[index];
    return row
      .slice(1)
      .map((cell) => (cell === "=" ? cell : isNaN(cell) ? null : cell))
      .map((cell, index) => {
        return {
          personType,
          opinion: cell === "=" ? 0 : cell,
          animal: {
            sex,
            ...headers[index],
          },
        };
      });
  });
};

const getComercializadoresFemaleData = (rawTable) => {
  let headers = [];
  // Headers bovinos
  Object.values(Animals[VACUNO_HEMBRA_KEY].weight).forEach((weight) => {
    return Object.values(Animals[VACUNO_HEMBRA_KEY].fatType).forEach(
      (fatType) => {
        headers = [
          ...headers,
          {
            weight,
            fatType,
            type: VACUNO,
          },
        ];
      }
    );
  });
  // Get data
  return getDataFromOpinionsTable(rawTable, headers, HEMBRA, COMERCIALIZADOR);
};

const getProductoresFemaleData = (rawTable) => {
  let headers = [];
  // Headers bovinos
  Object.values(Animals[VACUNO_HEMBRA_KEY].weight).forEach((weight) => {
    return Object.values(Animals[VACUNO_HEMBRA_KEY].fatType).forEach(
      (fatType) => {
        headers = [
          ...headers,
          {
            weight,
            fatType,
            type: VACUNO,
          },
        ];
      }
    );
  });
  // Get data
  return getDataFromOpinionsTable(rawTable, headers, HEMBRA, PRODUCTOR);
};

const getComercializadoresMaleData = (rawTable) => {
  let headers = [];
  // Headers bovinos
  Object.values(Animals[VACUNO_MACHO_KEY].weight).forEach((weight) => {
    return Object.values(Animals[VACUNO_MACHO_KEY].fatType).forEach(
      (fatType) => {
        headers = [
          ...headers,
          {
            weight,
            fatType,
            type: VACUNO,
          },
        ];
      }
    );
  });
  // Headers frison
  Object.values(Animals[FRISON_MACHO_KEY].weight).forEach((weight) => {
    return Object.values(Animals[FRISON_MACHO_KEY].fatType).forEach(
      (fatType) => {
        headers = [
          ...headers,
          {
            weight,
            fatType,
            type: FRISON,
          },
        ];
      }
    );
  });
  // Get data
  return getDataFromOpinionsTable(rawTable, headers, MACHO, COMERCIALIZADOR);
};

const getProductoresMaleData = (rawTable) => {
  let headers = [];
  // Headers bovinos
  Object.values(Animals[VACUNO_MACHO_KEY].weight).forEach((weight) => {
    return Object.values(Animals[VACUNO_MACHO_KEY].fatType).forEach(
      (fatType) => {
        headers = [
          ...headers,
          {
            weight,
            fatType,
            type: VACUNO,
          },
        ];
      }
    );
  });
  // Headers frison
  Object.values(Animals[FRISON_MACHO_KEY].weight).forEach((weight) => {
    return Object.values(Animals[FRISON_MACHO_KEY].fatType).forEach(
      (fatType) => {
        headers = [
          ...headers,
          {
            weight,
            fatType,
            type: FRISON,
          },
        ];
      }
    );
  });
  // Get data
  return getDataFromOpinionsTable(rawTable, headers, MACHO, PRODUCTOR);
};

const getAvgFemaleData = (rawTable) => {
  let headers = [];
  // Headers bovinos
  Object.values(Animals[VACUNO_HEMBRA_KEY].weight).forEach((weight) => {
    return Object.values(Animals[VACUNO_HEMBRA_KEY].fatType).forEach(
      (fatType) => {
        headers = [
          ...headers,
          {
            weight,
            fatType,
            type: VACUNO,
          },
        ];
      }
    );
  });
  // Get data
  return getDataFromAvgOpinionsTable(rawTable, HEMBRA, headers);
};

const getAvgMaleData = (rawTable) => {
  let headers = [];
  // Headers bovinos
  Object.values(Animals[VACUNO_HEMBRA_KEY].weight).forEach((weight) => {
    return Object.values(Animals[VACUNO_HEMBRA_KEY].fatType).forEach(
      (fatType) => {
        headers = [
          ...headers,
          {
            weight,
            fatType,
            type: VACUNO,
          },
        ];
      }
    );
  });
  // Headers frison
  Object.values(Animals[FRISON_MACHO_KEY].weight).forEach((weight) => {
    return Object.values(Animals[FRISON_MACHO_KEY].fatType).forEach(
      (fatType) => {
        headers = [
          ...headers,
          {
            weight,
            fatType,
            type: FRISON,
          },
        ];
      }
    );
  });
  // Get data
  return getDataFromAvgOpinionsTable(rawTable, MACHO, headers);
};

const getAliveMaleForSlaughterData = (rawTable) => {
  const headers = [
    SELECTO,
    CRUZADO_1,
    CRUZADO_2,
    MONTBELIARD_SIMMENTAL_ETC,
    FRISON,
  ];
  // Get data
  const rawData = rawTable
    .slice(3)
    // Delete first column
    .map((row) => row.slice(1))
    // Convert non numeric values to null
    .map((row) => row.map((cell) => (isNaN(cell) ? null : cell)));

  let data = [];
  headers.forEach((header, index) => {
    data[index] = {
      animal: {
        type: header,
        sex: MACHO,
      },
      min: rawData[index][0],
      minVariation: rawData[index][1],
      max: rawData[index][3],
      maxVariation: rawData[index][4],
    };
  });
  return data;
};

const getCowsData = (rawTable) => {
  let headers = [];
  Object.values(Animals[VACA_KEY].weight).forEach((weight) => {
    return Object.values(Animals[VACA_KEY].fatType).forEach((fatType) => {
      headers = [
        ...headers,
        {
          weight,
          fatType,
          type: VACA,
          sex: HEMBRA,
        },
      ];
    });
  });
  // Get data
  const data = rawTable
    .slice(4)
    .flatMap((row) => {
      let lastCell;
      return row.slice(1).map((cell, index) => {
        if ((index + 1) % 3 === 0) {
          return {
            price: lastCell === "=" ? 0 : lastCell,
            variation: cell === "=" ? 0 : cell,
            animal: { ...headers.shift() },
          };
        }
        lastCell = cell;
        return null;
      });
    })
    // Remove null values
    .filter((row) => row !== null)
    // Convert non numeric values to null
    .map((row) => {
      return {
        ...row,
        price: isNaN(row.price) ? null : row.price,
        variation: isNaN(row.variation) ? null : row.variation,
      };
    });
  return data;
};

const getAvgMaleDataNewPrice = (rawTable) => {
  let headers = [];
  // Headers bovinos
  Object.values(Animals[VACUNO_MACHO_KEY].weight).forEach((weight) => {
    return Object.values(Animals[VACUNO_MACHO_KEY].fatType).forEach(
      (fatType) => {
        headers = [
          ...headers,
          {
            weight,
            fatType,
            type: VACUNO,
            sex: MACHO,
          },
        ];
      }
    );
  });
  // Headers frison
  Object.values(Animals[FRISON_MACHO_KEY].weight).forEach((weight) => {
    return Object.values(Animals[FRISON_MACHO_KEY].fatType).forEach(
      (fatType) => {
        headers = [
          ...headers,
          {
            weight,
            fatType,
            type: FRISON,
            sex: MACHO,
          },
        ];
      }
    );
  });
  // Get data
  return rawTable.slice(2).flatMap((row, rowIndex) => {
    return (
      row
        .slice(1)
        // Convert non numeric values to null except for =
        .map((cell) => (cell === "=" ? cell : isNaN(cell) ? null : cell))
        .map((cell, index) => {
          return rowIndex === 0
            ? {
                type: "price",
                price: cell,
                animal: {
                  ...headers[index],
                },
              }
            : {
                type: "variation",
                variation: cell,
                animal: {
                  ...headers[index],
                },
              };
        })
        // Filter empty cells
        .filter((cell) => cell.price !== null)
        .filter((cell) => cell.variation !== null)
    );
  });
};

const getAvgFemaleDataNewPrice = (rawTable) => {
  let headers = [];
  // Headers bovinos
  Object.values(Animals[VACUNO_HEMBRA_KEY].weight).forEach((weight) => {
    return Object.values(Animals[VACUNO_HEMBRA_KEY].fatType).forEach(
      (fatType) => {
        headers = [
          ...headers,
          {
            weight,
            fatType,
            type: VACUNO,
            sex: HEMBRA,
          },
        ];
      }
    );
  });
  // Get data
  return rawTable.slice(2).flatMap((row, rowIndex) => {
    return (
      row
        .slice(1)
        // Convert non numeric values to null except for =
        .map((cell) => (cell === "=" ? cell : isNaN(cell) ? null : cell))
        .map((cell, index) => {
          return rowIndex === 0
            ? {
                type: "price",
                price: cell,
                animal: {
                  ...headers[index],
                },
              }
            : {
                type: "variation",
                variation: cell,
                animal: {
                  ...headers[index],
                },
              };
        })
        // Filter empty cells
        .filter((cell) => cell.price !== null)
        .filter((cell) => cell.variation !== null)
    );
  });
};

// --------
const verifyNewPriceData = (maleTable, femaleTable) => {
  // Check for non numeric values
  maleTable = maleTable.slice(2);
  for (let i = 0; i < maleTable.length; i++) {
    const row = maleTable[i];
    for (let j = 1; j < row.length; j++) {
      if (row[j] !== "=" && isNaN(row[j])) {
        return `Valores no numéricos en machos, revise la celda ${String.fromCharCode(
          65 + j
        )}${i + 3} (${row[j]}€)`;
      } else if ((i === 0) & (row[j] < 2)) {
        return `Precio menor a 2€ en machos, revise la celda ${String.fromCharCode(
          65 + j
        )}${i + 3} (${row[j]}€)`;
      } else if (i === 1 && (row[j] <= -1 || row[j] >= 1)) {
        return `Variación fuera del rango (-1,1)€ en machos, revise la celda ${String.fromCharCode(
          65 + j
        )}${i + 3} (${row[j]}€)`;
      }
    }
  }

  femaleTable = femaleTable.slice(2);
  for (let i = 0; i < femaleTable.length; i++) {
    const row = femaleTable[i];
    for (let j = 1; j < row.length; j++) {
      if (row[j] !== "=" && isNaN(row[j])) {
        return `Valores no numéricos en hembras, revise la celda ${String.fromCharCode(
          65 + j
        )}${i + 3} (${row[j]}€)`;
      } else if ((i === 0) & (row[j] < 2)) {
        return `Precio menor a 2€ en hembras, revise la celda ${String.fromCharCode(
          65 + j
        )}${i + 3} (${row[j]}€)`;
      } else if (i === 1 && (row[j] <= -1 || row[j] >= 1)) {
        return `Variación fuera del rango (-1,1)€ en hembras, revise la celda ${String.fromCharCode(
          65 + j
        )}${i + 3} (${row[j]}€)`;
      }
    }
  }
  return null;
};

const verifyComProdData = (
  comMaleTable,
  comFemaleTable,
  prodMaleTable,
  prodFemaleTable
) => {
  // Check for duplicated codes
  const comMaleCodes = comMaleTable
    .slice(2)
    .map((row) => row[0])
    .filter((code) => code !== null);
  // Detect duplicated codes and return them
  let duplicates = comMaleCodes.filter(
    (code, index) => comMaleCodes.indexOf(code) !== index
  );
  if (duplicates.length > 0) {
    return `Códigos duplicados en comercializadores machos: ${duplicates.join(
      ", "
    )}`;
  }
  const comFemaleCodes = comFemaleTable
    .slice(2)
    .map((row) => [row[0], row[1]])
    .filter((code) => code !== null);
  duplicates = comFemaleCodes.filter(
    (code, index) => comFemaleCodes.indexOf(code) !== index
  );
  if (duplicates.length > 0) {
    return `Códigos duplicados en comercializadores hembras: ${duplicates.join(
      ", "
    )}`;
  }
  const prodMaleCodes = prodMaleTable
    .slice(2)
    .map((row) => row[0])
    .filter((code) => code !== null);
  duplicates = prodMaleCodes.filter(
    (code, index) => prodMaleCodes.indexOf(code) !== index
  );
  if (duplicates.length > 0) {
    return `Códigos duplicados en productores machos: ${duplicates.join(", ")}`;
  }
  const prodFemaleCodes = prodFemaleTable
    .slice(2)
    .map((row) => row[0])
    .filter((code) => code !== null);
  duplicates = prodFemaleCodes.filter(
    (code, index) => prodFemaleCodes.indexOf(code) !== index
  );
  if (duplicates.length > 0) {
    return `Códigos duplicados en productores hembras: ${duplicates.join(
      ", "
    )}`;
  }
  // Check for empty codes where there is a name
  const comFemaleCodesAndNames = comFemaleTable
    .slice(2)
    .map((row) => [row[0], row[1]])
    .filter((row) => row[1] !== null);
  let emptyCodes = comFemaleCodesAndNames.filter(
    (row) => row[0] === null && row[1] !== null
  );
  if (emptyCodes.length > 0) {
    return `Códigos vacíos en comercializadores hembras: ${emptyCodes.join(
      ", "
    )}`;
  }
  const prodFemaleCodesAndNames = prodFemaleTable
    .slice(2)
    .map((row) => [row[0], row[1]])
    .filter((row) => row[1] !== null);
  emptyCodes = prodFemaleCodesAndNames.filter(
    (row) => row[0] === null && row[1] !== null
  );
  if (emptyCodes.length > 0) {
    return `Códigos vacíos en productores hembras: ${emptyCodes.join(", ")}`;
  }
  const comMaleCodesAndNames = comMaleTable
    .slice(2)
    .map((row) => [row[0], row[1]])
    .filter((row) => row[1] !== null);
  emptyCodes = comMaleCodesAndNames.filter(
    (row) => row[0] === null && row[1] !== null
  );
  if (emptyCodes.length > 0) {
    return `Códigos vacíos en comercializadores machos: ${emptyCodes.join(
      ", "
    )}`;
  }
  const prodMaleCodesAndNames = prodMaleTable
    .slice(2)
    .map((row) => [row[0], row[1]])
    .filter((row) => row[1] !== null);
  emptyCodes = prodMaleCodesAndNames.filter(
    (row) => row[0] === null && row[1] !== null
  );
  if (emptyCodes.length > 0) {
    return `Códigos vacíos en productores machos: ${emptyCodes.join(", ")}`;
  }
  // In female tables, check if for the same code there is the same name
  for (let i = 0; i < comFemaleCodesAndNames.length; i++) {
    const rowCom = comFemaleCodesAndNames[i];
    const prod = comMaleCodesAndNames.find(
      (rowProd) => rowProd[0] === rowCom[0]
    );
    if (
      prod &&
      rowCom[1].replace(/\s\s+/g, " ") !== prod[1].replace(/\s\s+/g, " ")
    ) {
      return `Nombre distinto para el mismo código en comercializadores y productores hembras: ${rowCom[0]}`;
    }
  }
  // In male tables, check if for the same code there is the same name
  for (let i = 0; i < comMaleCodesAndNames.length; i++) {
    const rowCom = comMaleCodesAndNames[i];
    const prod = prodFemaleCodesAndNames.find(
      (rowProd) => rowProd[0] === rowCom[0]
    );
    if (
      prod &&
      rowCom[1].replace(/\s\s+/g, " ") !== prod[1].replace(/\s\s+/g, " ")
    ) {
      return `Nombre distinto para el mismo código en comercializadores y productores machos: ${rowCom[0]}`;
    }
  }
};
export {
  getAliveMaleForSlaughterData,
  getAvgFemaleData,
  getAvgFemaleDataNewPrice,
  getAvgMaleData,
  getAvgMaleDataNewPrice,
  getComercializadoresFemaleData,
  getComercializadoresMaleData,
  getCowsData,
  getProductoresFemaleData,
  getProductoresMaleData,
  verifyComProdData,
  verifyNewPriceData,
};
